import { Base } from './base';
import { Currency, TariffType } from './index';

export class Tariff extends Base {
    TariffID: number;
    TariffTypeID: number;
    CurrencyID: number;
    OwnerID: string;
    Price: number;
    Date: Date;
    IsDefault: boolean;
    IsDeleted: boolean;

    id: number;

    // Navigation properties
    Currency: Currency;
    TariffType: TariffType;

    // Constructors
    constructor(tariffTypeId?: number, currencyId?: number, price?: number) {
        super();
        this.TariffTypeID = tariffTypeId;
        this.CurrencyID = currencyId;
        this.Price = price;
    }
}
